import { getAuthenticated } from '../../../../services/RestTemplate';

const auditApi = '/audit';

/*
  The audit events, a page of them. Without a jurisdiction the events about sandboxes are left out; naming a sandbox gives its events
  only, and only to whoever may see it.
*/
export const getAuditEvents = ({
    page,
    pageSize,
    sortType,
    sortOrder,
    jurisdiction,
    eventType
} = {}) =>
    getAuthenticated(auditApi, {
        page,
        pageSize,
        sortType,
        sortOrder,
        jurisdiction: jurisdiction || undefined,
        eventType: eventType || undefined
    });

/*
  The admins, by id, to say who did what in the trail. GET /auth/users needs the ADMIN role and no permission, where GET /users needs
  VIEW_USER_LIST: whoever may read the audit log (VIEW_AUDIT_LOG) has not the right to manage users.
*/
export const getAuditUsers = () => getAuthenticated('/auth/users');
